/**
 * Constants file for React Route paths
 */

export const HOME_PATH = "/";
export const USER_PATH = "user";
export const ACCEPTED_TRANSACTIONS_PATH = "accepted-transactions";
export const ACQUIRED_TRANSACTIONS_PATH = "acquired-transactions";
export const SETTLEMENTS_PATH = "settlements";
export const PORTFOLIO_PATH = "portfolio";
export const LOGIN_PATH = "login";
export const RESET_PASSWORD_PATH = "reset-password";
export const RESET_PASSWORD_CONFIRM_PATH = "confirm";
export const COMPONENTS_PATH = "components";
export const UPDATE_PASSWORD_PATH = "update-password";
// User pages
export const MY_ACCOUNT_PATH = "account";
export const MY_REPORTS_PATH = "reports";
export const DOCUMENTS_PATH = "documents";
export const CHANGE_PASSWORD_PATH = "change-password";
export const NOTIFICATION_SETTINGS_PATH = "notifications-settings";
